import { ActionFunctionArgs, Form, redirect, useLoaderData } from "react-router-dom";
import toast from "react-hot-toast";
import { createApolloClient } from "../../providers/ApolloClientFactory";
import { organizationStore } from "../../store/organization";
import { userStore } from "../../store/user";
import { GET_LIST_EVENTS_BY_ORGANIZATION } from "../../queries";
import { PrimaryButton } from "../../components/Button";
import { CREATE_INVOICE_ITEM } from "./mutations";
import { InvoiceItemForm, readInvoiceItemForm } from "./InvoiceItemForm";

const client = createApolloClient();
const { getState: getUserState } = userStore;
const { getState: getOrganizationState } = organizationStore;

const eventsWhere = () => {
  const organizationId = getOrganizationState().organizationId;
  const user = getUserState().user;
  const where: any = {};
  if (organizationId) {
    where.organization_id = { _eq: organizationId };
    where.is_active = { _eq: true };
  }
  if (user?.events?.length) where.id = { _in: user.events };
  return where;
};

export const invoiceItemCreateLoader = async () => {
  const { data } = await client.query({
    query: GET_LIST_EVENTS_BY_ORGANIZATION,
    variables: { where: eventsWhere() },
  });
  return {
    events: (data?.events ?? []) as { id: number; name: string }[],
    organizationId: getOrganizationState().organizationId as number | null,
  };
};

export const invoiceItemCreateAction = async ({ request }: ActionFunctionArgs) => {
  const body = await request.formData();
  const input = readInvoiceItemForm(body, getUserState().user?.id);
  if (!input.name) {
    toast.error("Item name is required");
    return null;
  }
  if (!input.organization_id) {
    toast.error("Select an organization first");
    return null;
  }
  try {
    await client.mutate({ mutation: CREATE_INVOICE_ITEM, variables: { input } });
    await client.clearStore();
    toast.success("Invoice item created");
    return redirect("/invoice-items/list");
  } catch (error) {
    toast.error("Failed to create invoice item: " + error);
    return null;
  }
};

export const InvoiceItemCreate = () => {
  const { events, organizationId } = useLoaderData() as {
    events: { id: number; name: string }[];
    organizationId: number | null;
  };
  return (
    <Form method="post" action="/invoice-items/create">
      <InvoiceItemForm organizationId={organizationId} events={events}>
        <div className="col-span-6 flex justify-end">
          <PrimaryButton type="submit">Create Invoice Item</PrimaryButton>
        </div>
      </InvoiceItemForm>
    </Form>
  );
};
